import F from "@babel/runtime/helpers/esm/slicedToArray";
import y from "@babel/runtime/helpers/esm/objectSpread2";
import W from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import R from "@babel/runtime/helpers/esm/classCallCheck";
import E from "@babel/runtime/helpers/esm/createClass";
import c from "@babel/runtime/helpers/esm/assertThisInitialized";
import k from "@babel/runtime/helpers/esm/inherits";
import D from "@babel/runtime/helpers/esm/createSuper";
import _ from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as O } from "@semcore/utils/lib/core/index";
import $, { sstyled as S, assignProps as C, Component as V } from "@semcore/core";
import l from "react";
import z from "@semcore/input";
import P from "@semcore/scroll-area";
import B, { TagContainer as b } from "@semcore/tag";
import A from "@semcore/utils/lib/fire";
import { ScreenReaderOnly as K } from "@semcore/flex-box";
import N from "@semcore/utils/lib/uniqueID";
import j from "@semcore/portal";
import { localizedMessages as L } from "./translations/__intergalactic-dynamic-locales.mjs";
import H from "@semcore/utils/lib/enhances/i18nEnhance";
import { isAdvanceMode as U, extractFrom as q } from "@semcore/utils/lib/findComponent";
import { getAccessibleName as G } from "@semcore/utils/lib/getAccessibleName";
var J = (
  /*__reshadow_css_start__*/
  (O.insert(
    /*__inner_css_start__*/
    '.___SInputTags_1m190_gg_{box-sizing:border-box;cursor:text;align-items:flex-start;overflow:visible;overflow:initial}.___SInputTags_1m190_gg_ .___SContainer_1m190_gg_:focus .___SOutline_1m190_gg_{border-color:var(--intergalactic-border-info-active, #006dca);box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5))}.___SInputTags_1m190_gg_ .___SContainer_1m190_gg_:focus:has(.___SOutline_1m190_gg_)::after{box-shadow:none}.___SContainer_1m190_gg_{padding:1px 0;box-sizing:border-box;border-bottom:1px solid transparent;border-top:1px solid transparent}.___SInputTags_1m190_gg_>div>div{display:flex;align-items:center;flex-flow:row wrap}.___SInputTags_1m190_gg_>div[data-ui-name="ScrollArea.Bar"]._orientation_vertical_1m190_gg_{right:1px!important}.___SInputTags_1m190_gg_._size_m_1m190_gg_{min-height:var(--intergalactic-form-control-m, 28px);height:auto;padding:0 calc(var(--intergalactic-spacing-1x, 4px) + var(--intergalactic-spacing-05x, 2px))}.___SInputTags_1m190_gg_._size_l_1m190_gg_{min-height:var(--intergalactic-form-control-l, 40px);height:auto;padding:0 calc(var(--intergalactic-spacing-2x, 8px) + var(--intergalactic-spacing-05x, 2px))}.___STagContainer_1m190_gg_{margin:var(--intergalactic-spacing-05x, 2px)}.___STagContainer_1m190_gg_.__editable_1m190_gg_{cursor:pointer}.___SInputTags_1m190_gg_._size_m_1m190_gg_ .___SValue_1m190_gg_{height:calc(var(--intergalactic-form-control-m, 28px) - var(--intergalactic-spacing-1x, 4px))}.___SInputTags_1m190_gg_._size_l_1m190_gg_ .___SValue_1m190_gg_{height:calc(var(--intergalactic-form-control-l, 40px) - var(--intergalactic-spacing-1x, 4px))}.___SValue_1m190_gg_{padding:0!important;margin-left:var(--intergalactic-spacing-05x, 2px);margin-right:var(--intergalactic-spacing-05x, 2px)}.___SSpacer_1m190_gg_{position:absolute;top:0;left:0;visibility:hidden;height:0;overflow:scroll;white-space:pre;font-family:inherit;font-size:inherit;font-weight:inherit;font-style:inherit;letter-spacing:inherit;text-transform:inherit}.___SListAriaWrapper_1m190_gg_{display:contents}',
    "1m190_gg_"
  ), {
    __SInputTags: "___SInputTags_1m190_gg_",
    __SContainer: "___SContainer_1m190_gg_",
    __SOutline: "___SOutline_1m190_gg_",
    _orientation_vertical: "_orientation_vertical_1m190_gg_",
    _size_m: "_size_m_1m190_gg_",
    _size_l: "_size_l_1m190_gg_",
    __STagContainer: "___STagContainer_1m190_gg_",
    _editable: "__editable_1m190_gg_",
    __SValue: "___SValue_1m190_gg_",
    __SSpacer: "___SSpacer_1m190_gg_",
    __SListAriaWrapper: "___SListAriaWrapper_1m190_gg_"
  })
), I = /* @__PURE__ */ function(n) {
  k(s, n);
  var u = D(s);
  function s() {
    var e;
    R(this, s);
    for (var i = arguments.length, r = new Array(i), a = 0; a < i; a++)
      r[a] = arguments[a];
    return e = u.call.apply(u, [this].concat(r)), _(c(e), "inputRef", /* @__PURE__ */ l.createRef()), _(c(e), "scrollContainerRef", /* @__PURE__ */ l.createRef()), _(c(e), "tagsRefs", []), _(c(e), "state", {
      tagsContainerAriaLabel: ""
    }), _(c(e), "moveFocusToInput", function(t) {
      var o = e.inputRef.current;
      if (o && t.target !== o) {
        var g = o.value.length;
        t.preventDefault(), o.focus(), o.setSelectionRange(g, g);
      }
    }), _(c(e), "handleKeyDown", function(t) {
      var o = t.key, g = t.currentTarget, p = e.asProps.delimiters, T = g.value, m = T.slice(-1), d = T.trim();
      if ((p != null && p.includes(o) || m === " " && o === " ") && d) {
        var h;
        t.preventDefault(), A(c(e), "onAdd", d, t), A(c(e), "onAppend", [d], t), typeof ((h = e.inputRef.current) === null || h === void 0 ? void 0 : h.scrollIntoView) == "function" && setTimeout(function() {
          var f;
          typeof ((f = e.inputRef.current) === null || f === void 0 ? void 0 : f.scrollIntoView) == "function" && e.inputRef.current.scrollIntoView({
            block: "nearest",
            inline: "nearest",
            behavior: "smooth"
          });
        }, 0);
      }
      o === "Backspace" && !T && (t.preventDefault(), A(c(e), "onRemove", t));
    }), _(c(e), "handlePaste", function(t) {
      var o, g = t.clipboardData.getData("text/plain"), p = e.asProps, T = p.delimiters, m = p.onAdd, d = p.onAppend, h = new RegExp(T.filter(function(v) {
        return !/\w+/.test(String(v));
      }).map(function(v) {
        return v.replace(/[\\^$*+?.()|[\]{}]/g, "\\$&");
      }).join("|")), f = g.split(h).filter(Boolean);
      if (f.length > 0) {
        t.preventDefault();
        var x = W(f), w;
        try {
          for (x.s(); !(w = x.n()).done; ) {
            var M = w.value;
            m == null || m(M, t);
          }
        } catch (v) {
          x.e(v);
        } finally {
          x.f();
        }
        d == null || d(f, t);
      }
      typeof ((o = e.inputRef.current) === null || o === void 0 ? void 0 : o.scrollIntoView) == "function" && setTimeout(function() {
        var v;
        typeof ((v = e.inputRef.current) === null || v === void 0 ? void 0 : v.scrollIntoView) == "function" && e.inputRef.current.scrollIntoView({
          block: "nearest",
          inline: "nearest",
          behavior: "smooth"
        });
      }, 0);
    }), _(c(e), "onTagClick", function(t) {
      A(c(e), "onRemove", t);
    }), e;
  }
  return E(s, [{
    key: "componentDidMount",
    value: function() {
      var i = this.inputRef.current, r = G(i);
      this.setState({
        tagsContainerAriaLabel: r
      });
    }
  }, {
    key: "getValueProps",
    value: function() {
      return {
        ref: this.inputRef,
        onKeyDown: this.handleKeyDown,
        onPaste: this.handlePaste
      };
    }
  }, {
    key: "getTagProps",
    value: function(i, r) {
      var a = this, t = i.editable;
      return {
        size: this.asProps.size,
        onClick: t ? this.onTagClick : void 0,
        interactive: t,
        ref: function(g) {
          a.tagsRefs[r] = g;
        }
      };
    }
  }, {
    key: "getTagTextProps",
    value: function(i, r) {
      return {
        uid: "".concat(this.asProps.uid, "-").concat(r),
        getI18nText: this.asProps.getI18nText
      };
    }
  }, {
    key: "getInputTagsContainerProps",
    value: function() {
      return {
        tagsContainerAriaLabel: this.state.tagsContainerAriaLabel
      };
    }
  }, {
    key: "getTagContainerTextContentProps",
    value: function() {
      return {
        tabIndex: null
      };
    }
  }, {
    key: "render",
    value: function() {
      var i = this.asProps, r, a = z, t = this.asProps, o = t.Children, g = t.styles, p = "ul", T = U(o, ["InputTags.TagsContainer"]);
      if (T) {
        var m;
        return m = S(g), /* @__PURE__ */ l.createElement(a, m.cn("SInputTags", y({}, C({
          tag: P,
          onMouseDown: this.moveFocusToInput,
          container: this.scrollContainerRef,
          tabIndex: null
        }, i))), /* @__PURE__ */ l.createElement(o, m.cn("Children", {})));
      }
      var d = q(o, ["InputTags.Value"]), h = F(d, 2), f = h[0], x = h[1];
      return r = S(g), /* @__PURE__ */ l.createElement(a, r.cn("SInputTags", y({}, C({
        tag: P,
        onMouseDown: this.moveFocusToInput,
        container: this.scrollContainerRef,
        tabIndex: null
      }, i))), /* @__PURE__ */ l.createElement(p, r.cn("SListAriaWrapper", {
        "aria-label": this.state.tagsContainerAriaLabel
      }), x), f);
    }
  }]), s;
}(V);
_(I, "displayName", "InputTags");
_(I, "style", J);
_(I, "enhance", [N(), H(L)]);
_(I, "defaultProps", {
  size: "m",
  delimiters: [",", ";", "|", "Enter", "Tab"],
  defaultValue: "",
  i18n: L,
  locale: "en"
});
var Q = /* @__PURE__ */ function(n) {
  k(s, n);
  var u = D(s);
  function s() {
    var e;
    R(this, s);
    for (var i = arguments.length, r = new Array(i), a = 0; a < i; a++)
      r[a] = arguments[a];
    return e = u.call.apply(u, [this].concat(r)), _(c(e), "_spacer", /* @__PURE__ */ l.createRef()), _(c(e), "state", {
      width: "10px"
    }), _(c(e), "handleChange", function(t) {
      e.updateInputStyles(t);
    }), _(c(e), "updateInputStyles", function(t) {
      var o = e._spacer.current;
      if (o) {
        var g = e.props.placeholder, p = 2;
        g && (t === void 0 || t === "") ? (o.innerText = g, p += 8) : o.innerText = t, e.setState({
          width: "".concat(Math.max(o.offsetWidth, o.scrollWidth) + p, "px")
        });
      }
    }), e;
  }
  return E(s, [{
    key: "componentDidMount",
    value: function() {
      this.updateInputStyles(this.asProps.value);
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      var r = this.asProps, a = r.value, t = r.placeholder;
      (a !== i.value || t !== i.placeholder) && this.updateInputStyles(a);
    }
  }, {
    key: "render",
    value: function() {
      var i = this.asProps, r, a = z.Value, t = "div";
      return r = S(this.asProps.styles), /* @__PURE__ */ l.createElement(l.Fragment, null, /* @__PURE__ */ l.createElement(a, r.cn("SValue", y({}, C({
        style: {
          width: this.state.width
        }
      }, i)))), /* @__PURE__ */ l.createElement(t, r.cn("SSpacer", {
        ref: this._spacer,
        "aria-hidden": !0
      })));
    }
  }]), s;
}(V);
function X(n) {
  var u, s = n.Children, e = n.tagsContainerAriaLabel, i = n.styles, r = "ul";
  return u = S(i), /* @__PURE__ */ l.createElement(r, u.cn("SListAriaWrapper", {
    "aria-label": e
  }), /* @__PURE__ */ l.createElement(s, u.cn("Children", {})));
}
function Y(n) {
  var u = arguments[0], s, e = b, i = l.useCallback(function(a) {
    if (n.onClick && (a.key === "Enter" || a.key === " "))
      return a.preventDefault(), n.onClick(a), !1;
  }, [n.onClick]), r = n.editable || n.onClick;
  return s = S(n.styles), /* @__PURE__ */ l.createElement(e, s.cn("STag", y({}, C({
    "data-value": n.value,
    tag: "li",
    onKeyDown: i,
    interactive: r
  }, u))));
}
function Z(n) {
  var u = arguments[0], s, e = b.Tag, i = n.getI18nText;
  n.editable;
  var r = l.useRef();
  return l.useEffect(function() {
    var a;
    if (r.current instanceof HTMLButtonElement || ((a = r.current) === null || a === void 0 ? void 0 : a.getAttribute("role")) === "button")
      r.current.setAttribute("aria-describedby", "".concat(n.uid, "-description"));
    else {
      var t;
      (t = r.current) === null || t === void 0 || t.removeAttribute("aria-describedby");
    }
  }, [r.current, n.uid]), s = S(n.styles), /* @__PURE__ */ l.createElement(l.Fragment, null, /* @__PURE__ */ l.createElement(j, s.cn("Portal", {}), /* @__PURE__ */ l.createElement(K, s.cn("ScreenReaderOnly", {
    id: "".concat(n.uid, "-description"),
    "aria-hidden": "true"
  }), i("pressEnterToEdit"))), /* @__PURE__ */ l.createElement(e, s.cn("STag", y({}, C({
    ref: r
  }, u)))));
}
function ee(n) {
  var u = arguments[0];
  return S(n.styles), /* @__PURE__ */ l.createElement(B.Text, C({}, u));
}
const ye = $(I, {
  Value: Q,
  TagsContainer: X,
  Tag: [Y, {
    Text: [Z, {
      Content: ee
    }],
    Close: b.Close,
    Addon: b.Tag.Addon,
    Circle: b.Circle
  }]
});
export {
  ye as default
};
